export default {
  appInfo: {
    state: {
      configuration: 'Konfiguration',
      downloaded: 'Heruntergeladen',
      heading: 'Informationen zum Anwendungsstatus',
      lastUpdated: 'Zuletzt aktualisiert',
      noConfiguration: 'Es steht keine Konfiguration zur Verfügung',
      questionsAnswered: 'Keine Fragen beantwortet | {n} Frage beantwortet | {n} Fragen beantwortet',
      storedResponses: 'Gespeicherte Umfrageantworten',
      surveyDetails: 'Umfrage Details',
      surveyInProgress: 'Eine Umfrage ist derzeit in Bearbeitung',
      surveyNotInProgress: 'Derzeit sind keine Umfragen in Bearbeitung',
      surveyProgress: 'Umfrage Fortschritt',
      surveysAvailable: 'Keine Umfragen verfügbar | {n} Umfrage verfügbar | {n} Umfragen verfügbar',
      surveysStored: 'Keine Antworten zur Übertragung vorhanden | {n} Antwort zur Übertragung vorhanden | {n} Antworten zur Übertragung vorhanden',
      updateAvailable: 'Aktualisierung verfügbar',
      updateDownloading: 'Aktualisierung wird heruntergeladen'
    },
    version: 'App-Version',
    appUpdated: 'App auf die neueste Version aktualisiert',
    sinceConfigUpdate: 'Sie haben die App-Konfiguration zuletzt gestern aktualisiert | Sie haben die App-Konfiguration vor {days} Tagen aktualisiert',
    sinceSurveyUpload: 'Ihre letzte abgeschlossene Umfrage wurde vor {days} Tagen hochgeladen | Ihre letzten abgeschlossenen Umfragen wurden vor {days} Tagen hochgeladen',
    sinceSurveyUploadYesterday: 'Ihre letzte abgeschlossene Umfrage wurde gestern hochgeladen | Ihre letzten abgeschlossenen Umfragen wurden gestern hochgeladen',
    sinceMenuItemUpdate: 'Sie haben die Menüpunkte zuletzt vor einer Woche aktualisiert | Sie haben die Menüpunkte vor {days} Tagen aktualisiert',
    install: {
      install: 'Installieren',
      installTitle: '125 Data & Insights installieren',
      installDesc: 'Wenn diese App noch nicht auf Ihrem Gerät installiert ist, installieren Sie sie bitte, um fortzufahren.',
      installInstructionsDesc: 'Wenn diese App bereits auf Ihrem Gerät installiert ist, öffnen Sie sie bitte vom Startbildschirm aus oder befolgen Sie die unten stehenden Anweisungen zur Installation.',
      installInstructionsLabel: 'Klicken Sie hier, um Anweisungen zur Installation anzuzeigen',
      appInstalled: 'App installiert',
      appInstalledDesc: 'Bitte öffnen Sie die App vom Startbildschirm aus, um fortzufahren.',
      iosPressShareButton: 'Drücken Sie die Teilen-Schaltfläche',
      iosPressAddToHomescreen: 'Drücken Sie "Zum Startbildschirm hinzufügen"',
      unsupportedDeviceTitle: 'Nicht unterstütztes Gerät',
      unsupportedDeviceDesc: 'Bitte verwenden Sie ein IOS- oder Android-Gerät.',
      unsupportedBrowserTitle: 'Nicht unterstützter Browser',
      unsupportedBrowserDesc: 'Diese App ist nur für {n} verfügbar.',
      pressMenuIcon: 'Drücken Sie das Menüsymbol in der Browser-Symbolleiste.',
      chromePressInstallApp: 'Dann drücken Sie "App installieren" und folgen Sie den Schritten, um die App auf Ihrem Gerät zu installieren.',
      samsungPressAddPageTo: 'Drücken Sie "Seite hinzufügen zu"',
      samsungPressHomeScreen: 'Drücken Sie "Startbildschirm" und befolgen Sie die Schritte',
      safari: 'Safari',
      samsungInternet: 'Samsung Internet',
      chrome: 'Chrome'
    }
  }
};